import {GridColDef} from '@mui/x-data-grid';
import {t} from 'i18next';
import {CustomMenuItem} from '../../common/arr-menu/ArrMenu';

export const manageTemplatesColumns: GridColDef[] = [
  {
    field: 'templateName',
    headerName: 'Name',
    flex: 1,
  },
  {
    field: 'setType',
    headerName: 'Template Type',
    flex: 1,
  },
  {field: 'templateDescription', headerName: 'Description', flex: 1},
  {
    field: 'isSecurityGroupTemplate',
    headerName: 'Security Group Template',
    flex: 1,
  },
  {field: 'userCreated', headerName: 'User Created', flex: 1},
  {field: 'dateCreated', headerName: 'Date Created', flex: 1},
  {field: 'lastModifiedBy', headerName: 'Last Modified By', flex: 1},
  {field: 'lastModifiedDate', headerName: 'Last Modified Date', flex: 1},
];

export const manageTemplateDetailsMoreMenu: CustomMenuItem[] = [
  {label: 'View', id: 'view'},
  {label: 'Delete', id: 'delete'},
];

export interface TabData {
  label: string;
}

export const getViewTemplateTabs = (): TabData[] => [
  {
    label: t(
      'productionsAndExports.manageTemplates.viewTemplateTabs.privGuard'
    ),
  },
  {
    label: t(
      'productionsAndExports.manageTemplates.viewTemplateTabs.productionComponents'
    ),
  },
  {
    label: t(
      'productionsAndExports.manageTemplates.viewTemplateTabs.numberingAndSorting'
    ),
  },
];

/**
 * Maps manage-templates `setType` to production vs export module behavior.
 * Export templates must not force DAT checked (DAT is optional for exports).
 */
export const isProductionSetFromTemplateSetType = (
  setType?: string | null
): boolean => {
  const normalized = (setType ?? '').trim().toUpperCase();
  if (normalized === 'EXPORT' || normalized === 'EXPORTS') {
    return false;
  }
  return true;
};
